import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';

interface Props {
  title: string;
}

export function PickerSectionTitle({ title }: Props) {
  return (
    <View paddingHorizontal={3} paddingTop={3}>
      <Text size="body2" weight="semibold">
        {title}
      </Text>
    </View>
  );
}
